import styles from "./ArticleLeadArt.module.scss";

import { ArticleLayout, ArticleLeadEmbedFragment } from "types/api";
import ArticleLeadFigure from "components/article/ArticleLeadFigure";
import IFrame from "components/IFrame";
import { gql } from "utils/urql";
import cx from "classnames";

const ArticleLeadEmbed = ({
  layout,
  ...props
}: {
  layout: ArticleLayout;
} & ArticleLeadEmbedFragment) => {
  return (
    <>
      {props.__typename === "LeadArtEmbed" && (
        <ArticleLeadFigure layout={layout} captionText={props.caption}>
          <IFrame
            className={cx(
              styles.embed,
              layout === ArticleLayout.Feature && styles.featureMedia
            )}
            src={props.src}
            width={props.width}
            height={props.height}
            title="Embedded interactive content"
          />
        </ArticleLeadFigure>
      )}
    </>
  );
};

ArticleLeadEmbed.fragment = gql`
  fragment articleLeadEmbed on LeadArtEmbed {
    src
    width
    height
    caption
  }
`;

export default ArticleLeadEmbed;
